module.exports = {"hello":"Hello","server":{"error":{"-1000":"Site information cannot be confirmed","-1001":"The site is not in operation"}}}